module.exports = __webpack_public_path__ + "img/burger.cea65e7d.png";